import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Education } from '../../models/education.model';
import { EducationMockService } from '../../services/education-mock.service';

@Component({
  selector: 'bwc-educations-list',
  templateUrl: './educations-list.component.html',
  styleUrls: ['./educations-list.component.scss'],
})
export class EducationsListComponent implements OnInit {
  educations: Education[] = [];
  visibleCount = 24;
  likedIds: number[] = [];
  searchWat = '';
  searchWaar = '';

  skillLabels = [
    'Excel',
    'Communicatie',
    'Projectmanagement',
    'Data-analyse',
    'Leiderschap',
    'Marketing',
    'ICT',
    'Financiën',
    'HR',
    'Design',
  ];

  constructor(
    private educationService: EducationMockService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.educationService.getEducations().subscribe(e => (this.educations = e));
    this.likedIds = this.educationService.getSavedIds();
  }

  get visibleEducations(): Education[] {
    return this.educations.slice(0, this.visibleCount);
  }

  get hasMore(): boolean {
    return this.visibleCount < this.educations.length;
  }

  loadMore(): void {
    this.visibleCount = Math.min(this.visibleCount + 24, this.educations.length);
  }

  isLiked(id: number): boolean {
    return this.likedIds.includes(id);
  }

  toggleLike(education: Education): void {
    const saved = this.educationService.toggleSaveEducation(education);
    this.likedIds = saved
      ? [...this.likedIds, education.id]
      : this.likedIds.filter(i => i !== education.id);
  }

  handleSearch(): void {
    const params: Record<string, string> = {};
    if (this.searchWat) params['wat'] = this.searchWat;
    if (this.searchWaar) params['waar'] = this.searchWaar;
    this.router.navigate(['/profile-check/educations/search'], { queryParams: params });
  }

  navigateToSkill(skill: string): void {
    this.router.navigate(['/profile-check/educations/skill', encodeURIComponent(skill.toLowerCase())]);
  }
}
